<template>

  <div class="share-container" @click="closeDiv">


    <div class="loading" v-if="fullScreenLoad">
      <van-loading type="spinner" size="30px"></van-loading>
    </div>

    <NavBar :shareItem="list" @NavBarLogin="NavBarLogin" @LogincloseModel="LogincloseModel"></NavBar>
    <ShareCodeModel :shareItem="list" @ShareCodeModelColse="ShareCodeModelColse" v-if="haveShareCode"></ShareCodeModel>


    <div v-if="!haveShareCode&&!havaShareFile" style="flex: 4;">1</div>

    <div class="section" v-if="!haveShareCode&&!havaShareFile">
      <div class="center-top-box">
        <div class="left-userdesc-wrapper">
          <div class="left-userdesc-username">
            <div v-show="historyFolderDesc.length" @click="backLevel(historyFolderDesc[historyFolderDesc.length-2])"
                 style="width: 27px;height: 26px;margin-right: 13px;cursor: pointer;display: flex;justify-content: center;align-items: center">
              <img
                  src="@/assets/images/share/pc-back.png"
                  style="width: 7px;height: 14px;">
            </div>
            <div v-if="getShowName().length>35" style="overflow: hidden;white-space: nowrap">
              <vue3-seamless-scroll
                  :list="getShowName().split('').slice(0,50)" :step="0.4"
                  :limitScrollNum="30" direction="left">
                            <span class="total-file-name">
                             &ensp;&ensp;&ensp;&ensp;&ensp;{{ getShowName() }}
                            </span>
              </vue3-seamless-scroll>
            </div>
            <span v-else>{{ getShowName() }}</span>
          </div>
          <span class="left-folder-desc">{{ getfolderDesc(1) }}</span>
        </div>
        <div class="right-userdesc-wrapper">
          <!--          checkList.length-->
          <img v-if="isFile" src="@/assets/images/share/pcdown.png" class="down-btn" @click="downFile">
          <img v-if="isFolder" src="@/assets/images/share/newsearch.png"
               :style="{marginRight: checkList.length? '54px' : '1px'}" class="folder-search"
               @click="searchModelShow=!searchModelShow">
          <img v-if="isFile||checkList.length" src="@/assets/images/share/pcsaveFile.png" class="save-img"
               @click="checkList.length?beforeSaveFileFolder(1):beforeSaveFileFolder(3)">
          <img v-show="isFolder&&!checkList.length" src="@/assets/images/share/transfer.png" class="checktransferimg"
               @click="transferFile">
          <img src="@/assets/images/share/pcreport.png" class="reportimg" @click="beforeReport">
        </div>
      </div>

      <div style="width: 94.5%;height: 0px;border: 1px solid #F5F5F6;border-radius: 2px;margin-left: 3%"></div>

      <div class="remote-search" ref="getSearchDom" v-if="searchModelShow">
        <div class="search-input-warpper">
          <div class="common-input">
            <input v-model="searchInputVal" class="common-input-inner" placeholder="搜索文件"
                   autofocus="autofocus" @keyup="searchData">
            <span class="common-input-clear" @click="closeSearch"
                  v-show="searchInputVal!=''">清空</span>
          </div>
          <span style="color: #e6e7e8;font-size: 12px;">|</span>
          <img class="common-input-close" src="@/assets/images/share/close.png"
               @click="closeSearch">
        </div>
        <div class="search-list" v-show="searchList.length" v-infinite-scroll="searchLoad"
             infinite-scroll-immediate="false" infinite-scroll-distance="1">
          <div class="search-item" v-for="(item,index) in searchList" :key="index" @click="searchItem(item)">
            <img :src="getimgUrl(item)"
                 style="height: 35px;width: 32px;font-size: 15px" @error="imgError(currentFileInfo.iconId)">
            <span
                style="margin-left: 22px;font-size: 14px;color: #6e6f74;max-width: 400px;white-space: nowrap;overflow: hidden">{{
                item.folderName || item.fileName
              }}</span>
          </div>
          <p v-show="searchLoadMore" class="list-loading">加载中...</p>
        </div>
      </div>


      <div class="list-container" v-show="isFolder">
        <div class="list-container-top">
          <el-checkbox style="margin-left: 35px" v-model="checkAll" @change="handleCheckAllChange"
                       :indeterminate="checkAll"></el-checkbox>
          <span style="margin-left: 20px">已选择{{ checkList.length }}项</span></div>
        <div class="list-header">
          <span class="list-header-first" @mouseenter="sortmounte(1)" @mouseleave="sortlevel(1)">
                        <span style="display: flex;margin-left: 71px">文件名/夹</span>
            <img src="@/assets/images/share/sortNewDown.png" class="sort-style"
                 v-show="!checkList.length&&( sortNameShow || sortParamsData.sort==null&&sortParamsData.rule==1)"
                 @click="sortList(0,1)">
            <img src="@/assets/images/share/sortNewUp.png" class="sort-style"
                 v-show="!checkList.length&&( sortParamsData.sort==0&&sortParamsData.rule==1)"
                 @click="sortList(null,1)"></span>
          <span class="list-header-second" @mouseenter="sortmounte(null)" @mouseleave="sortlevel(null)">时间
            <img src="@/assets/images/share/sortNewDown.png" class="sort-style"
                 v-show="!checkList.length&&( sortTimeShow || sortParamsData.sort==null&&sortParamsData.rule==null)"
                 @click="sortList(0,null)">
            <img src="@/assets/images/share/sortNewUp.png" class="sort-style"
                 v-show="!checkList.length&&( sortParamsData.sort==0&&sortParamsData.rule==null)"
                 @click="sortList(null,null)"> </span>
          <span class="list-header-third" @mouseenter="sortmounte(2)" @mouseleave="sortlevel(2)">大小
            <img src="@/assets/images/share/sortNewDown.png" class="sort-style"
                 v-show="!checkList.length&&( sortSizeShow || sortParamsData.sort==null&&sortParamsData.rule==2)"
                 @click="sortList(0,2)">
            <img src="@/assets/images/share/sortNewUp.png" class="sort-style"
                 v-show="!checkList.length&&( sortParamsData.sort==0&&sortParamsData.rule==2)"
                 @click="sortList(null,2)"></span>
        </div>
        <div class="list-wrapper" v-loading="dataLoading" v-infinite-scroll="load" infinite-scroll-immediate="false"
             infinite-scroll-distance="1">
          <van-checkbox-group v-model="checkList" ref="checkboxGroup" @change="handleCheckOne">
            <div class="list-item" @click="jump(item)" v-for="(item,index) in list[0].fileList" :key="index"
                 @mouseenter="listShowIcon=index" @mouseleave="listShowIcon=-1">

              <div class="name">
                <div class="group-checkbox" @click.stop="">
                  <van-checkbox style="margin-left: 23px" :name="item" checked-color="#0982FE" shape="square"
                                icon-size="16px"></van-checkbox>
                </div>
                <img class="list-img" :src="geticonUrl(item)" @error="imgError(item.iconId)">
                <div class="video-pause-container" v-if="item.iconId==6"></div>
                <img src="@/assets/images/pause.png" v-if="item.iconId==6" class="video-pause">
                <span class="list-name">{{ item.fileName || item.folderName }}</span>
                <div v-show="listShowIcon==index">
                  <img src="@/assets/images/share/list_down.png" class="list-down" v-if="item.fileType==1"
                       @click.stop="listDownFile(item)">
                  <!--                                  <img src="@/assets/images/share/list_transfer.png" class="list-transfer"-->
                  <!--                                       @click.stop="beforeSaveFileFolder(2,item)">-->
                </div>
              </div>

              <div class="time">{{ showTime(item.updTime) }}</div>
              <div class="size">{{ renderSize(item.fileSize) != '0KB' ? renderSize(item.fileSize) : '--' }}</div>
            </div>
          </van-checkbox-group>
          <p v-show="onloadMore" class="list-loading">加载中...</p>
          <p v-show="list[0].fileList.length==total&&total>12" class="list-loading">我是有底线的</p>
          <div class="empty-filelist-container" v-if="islistempty">
            <img src="@/assets/images/icon_empty_message.png" class="empty-filelist">
            <span class="empty-filelist-desc">没有分享文件</span>
          </div>
        </div>
      </div>

      <div v-if="isFile" class="centerimg-container">
        <div class="img-wrapper">
          <video ref="VideoDom" id="videoPlay" controlsList="nodownload"
                 v-if="currentFileInfo.iconId==6&&videoVipShow==true"
                 style="max-height: 491px;min-height: 260px;max-width: 90%;min-width: 500px;overflow-x: auto;overflow-y: auto"
                 controls
                 :poster="getCenterImgUrl(currentFileInfo)">
            <source :src="downFileCheck(currentFileInfo)" type="video/mp4">
          </video>
          <div v-else-if="currentFileInfo.iconId==5" style="display: flex;justify-content: center;align-items: center;">
            <audio id="audioPlay" controlsList="nodownload" controls ref="audioDom" @click="beforeReport">
              <source :src="downFileCheck(currentFileInfo,true)" type="audio/mp3">
            </audio>
          </div>
          <div v-else style="display: flex;justify-content: center;align-items: center">
            <img :class="currentFileInfo.iconId==16||currentFileInfo.iconId==6? 'img-center-active' : 'img-center'"
                 :style="{cursor: (videoVipShow&currentFileInfo.iconId==16)||(!videoVipShow&currentFileInfo.iconId==5)? 'pointer' : 'default'}"
                 @click="showPreviewImg()"
                 :src="getCenterImgUrl(currentFileInfo)" @error="imgError(currentFileInfo.iconId,true)">
            <div class="file-video-pause" v-if="currentFileInfo.iconId==6&&!videoVipShow" @click="whiteShow"></div>
            <img src="@/assets/images/pause.png" class="file-video-pause-img"
                 v-if="currentFileInfo.iconId==6&&!videoVipShow" @click="whiteShow">
          </div>
        </div>

        <div class="filename-container">
          <span class="filename">{{
              renderSize(currentFileInfo.fileSize)
            }} · {{ getIconInfo(currentFileInfo.iconId) }}</span>
        </div>

        <!--        <div v-if="currentFileInfo.iconId==5&&videoVipShow"-->
        <!--             style="width: 100%;display: flex;justify-content: center;margin-top: 20px">-->
        <!--          <audio id="audioPlay" controlsList="nodownload" controls>-->
        <!--            <source :src="downFileCheck(currentFileInfo,true)" type="audio/mp3">-->
        <!--          </audio>-->
        <!--        </div>-->
      </div>
    </div>

    <div v-if="!haveShareCode&&!havaShareFile" style="flex: 7;position: relative;min-width: 205px">
      <div class="user-info-fixed" v-if="!haveShareCode&&!havaShareFile">
        <img class="userimg" :src="getAvatarUrl(currentFolderDesc.avatar)">
        <span class="user-name">{{ currentFolderDesc.userName }}</span>
        <span class="share-time">{{ getfolderDesc(2) }}</span>
      </div>
    </div>

    <LoginModel v-if="dialogVisible" :ModelShow="dialogVisible" @LogincloseModel="LogincloseModel"></LoginModel>

    <PcReportModel v-if="Reportdialog" :Reportdialog="Reportdialog" @PcReportcloseModel="PcReportcloseModel"
                   @PcReport="PcReport"></PcReportModel>

    <div class="mydialog" v-if="SaveFiledialog">
      <div class="mydialog-voerlay">
        <div class="SaveFileModel">
          <div class="sava-header">
            <span style="margin-left: 26px;font-size: 16px;padding-top: 6px">保存到</span>
            <img style="width: 20px;margin-right: 20px" src="@/assets/images/share/close.png"
                 @click="cancleSaveFile()">
          </div>
          <div style="flex: 1;overflow: auto;width: 100%;">
            <div style="height: 100%;display: flex;flex-direction: column;overflow: hidden;padding-left: 26px">
              <div
                  style="font-size: 15px;height: 30px;line-height: 30px;margin-bottom: 3px;display: flex;color: rgb(187, 187, 187);">
                <span style="cursor: pointer;" @click="saveFolderJumpLevel('firstAll')">全部文件</span>
                <div v-for="(item,index) in historySaveFolderInfo" :key="index" @click="saveFolderJumpLevel(item)"
                     style="display: flex;align-items: center;margin-left: 2px;max-width: 100px;overflow: hidden;white-space: nowrap;text-overflow: ellipsis;;cursor: pointer;">
                  <img
                      src="@/assets/images/share/right.png" style="width: 18px">
                  <span style="max-width: 80px;overflow: hidden;white-space: nowrap;text-overflow: ellipsis">{{
                      item.folderName
                    }}</span>
                </div>
              </div>
              <div style="flex: 1;overflow: auto;">
                <el-scrollbar height="340px">
                  <div style="height: 50px;width: 100%;display: flex;align-items: center;" v-show="newFolderInputShow">
                    <img src="@/assets/images/tab_file/icon/folder.png" style="width: 32px;height: 32px">
                    <input v-model="newFloderName" type="text" maxlength="200"
                           style="border: none;outline: none;width: 370px;height: 30px;margin-left: 22px;background-color: #F3F3F3">
                    <img @click="saveNewFolder" src="@/assets/images/share/gou.png"
                         style="width: 20px;height: 20px;margin-left: 12px;cursor: pointer;">
                    <img @click="newFolderInputShow=false,newFloderName='新建文件夹'"
                         src="@/assets/images/share/叉叉.png"
                         style="width: 20px;height: 20px;margin-left: 15px;cursor: pointer;">
                  </div>
                  <div class="saveFileItem" v-for="(item,index) in folderList" :key="index"
                       @click="savaFileJump(item)">
                    <img src="@/assets/images/tab_file/icon/folder.png"
                         style="height: 35px;width: 32px;font-size: 15px">
                    <span
                        style="margin-left: 22px;font-size: 14px;color: #6e6f74;max-width: 400px;white-space: nowrap;overflow: hidden">{{
                        item.folderName
                      }}</span>
                  </div>
                </el-scrollbar>
              </div>
            </div>
          </div>
          <div
              style="height: 65px;width: 100%;border-radius: 0 0 20px 20px;background-color: #F2F2F2;display: flex;align-items: center">
            <button @click="newFolderInputShow=true"
                    style="width: 100px;height: 38px;border: none;outline: none;font-size: 15px;background-color: white;border-radius: 10px;margin-left: 20px;cursor: pointer;">
              新建文件夹
            </button>
            <button @click="cancleSaveFile()"
                    style="width: 100px;height: 38px;border: none;outline: none;font-size: 15px;background-color: #D5D5D5;border-radius: 10px;color: white;margin-left: 180px;cursor: pointer;">
              取消
            </button>
            <button @click="saveFileToFolder()"
                    style="width: 100px;height: 38px;border: none;outline: none;font-size: 15px;background-color: #0982FE;border-radius: 10px;color: white;margin-left: 20px;cursor: pointer;">
              保存
            </button>
          </div>
        </div>
      </div>
    </div>

    <div class="search-file-container" v-if="FileInfoShow">
      <div class="contain-wrapper">
        <div class="search-header">
          <img src="@/assets/images/share/close.png" class="search-close" @click="closeSearchFile">
          <span class="search-title">{{ currentFileInfo.fileName }}</span>
        </div>
        <div class="search-center">
          <div class="searchimg-wrapper">
            <video controlsList="nodownload" v-if="currentFileInfo.iconId==6&&videoVipShow==true"
                   style="max-height: 270px;min-height: 200px;max-width: 80%;min-width: 500px;overflow-x: auto;overflow-y: auto"
                   controls
                   :poster="getCenterImgUrl(currentFileInfo)">
              <source :src="downFileCheck(currentFileInfo)" type="video/mp4">
            </video>
            <div v-else>
              <img :class="videoVipShow? 'img-center' : 'img-center'" @click="showPreviewImg()"
                   :src="getCenterImgUrl(currentFileInfo)" @error="imgError(currentFileInfo.iconId)">
              <div class="file-video-pause" v-if="currentFileInfo.iconId==6&&!videoVipShow"></div>
              <img src="@/assets/images/pause.png" class="file-video-pause-img"
                   v-if="currentFileInfo.iconId==6&&!videoVipShow">
            </div>
          </div>
          <div class="filename-container">
            <span class="filename">{{ currentFileInfo.fileName }}</span>
          </div>
          <span v-show="getFileType(currentFileInfo.fileName)!='image'"
                class="filesize">{{
              renderSize(currentFileInfo.fileSize) != '0 KB' ? renderSize(currentFileInfo.fileSize) : '-'
            }}</span>

          <div v-if="currentFileInfo.iconId==5&&videoVipShow"
               style="padding-top: 10px;width: 100%;display: flex;justify-content: center">
            <audio controls controlsList="nodownload">
              <source :src="downFileCheck(currentFileInfo,true)" type="audio/mp3">
            </audio>
          </div>

          <div class="btn-container">
            <button class="down" @click="downFile">下载</button>
            <button class="save" @click="beforeSaveFileFolder(3)">保存至网盘</button>
            <!--            <button class="presee" v-show="getFileType(currentFileInfo.fileName)=='image'" @click="showPreviewImg()">预览-->
            <!--            </button>-->
          </div>
        </div>
      </div>
    </div>


    <div v-if="jumpPc"
         style="position: fixed;z-index: 1026;width: 276px;height: 45px;background: rgba(0, 0, 0, 0.8);border-radius: 26px;
        top: 15%;left: 50%;transform: translateX(-50%);display: flex;align-items: center;font-family: 'PingFang SC';font-size: 13px;">
<span
    style="width: 192px;margin-left: 15px;height: 20px;color: white;overflow: hidden;text-overflow: ellipsis;white-space: nowrap;">文件已保存至&nbsp;&nbsp;
  <span style="font-weight: 900;font-size: 14px">
    {{
      jumpPcObj.folderName == '' ? '我的文件' : jumpPcObj.folderName
    }}
  </span>
  </span>
      <div style="width: 0px;height: 12px;background: #FFFFFF;opacity: 0.3;border: 0.5px solid #FFFFFF;"></div>
      <span style="color: white;margin-left: 10px;cursor: pointer;" @click="jumpTOpC">查看></span>
    </div>

    <WhiteUser v-if="WhiteUserDialog" :WhiteUserDialog="WhiteUserDialog" :ShareId="currentFolderDesc.shareId"
               :account="FirstBeginOuterData.map.account"
               @closeWhiteUserModel="closeWhiteUserModel" @downFile="downFile"></WhiteUser>

    <VipModel v-if="VipModelShow" :ModelShow="VipModelShow" :toVipType="toVipType"
              @VipcloseModel="VipcloseModel"></VipModel>

    <div class="emptyFile" v-if="havaShareFile">
      <img src="@/assets/images/icon_empty_message.png" class="emptyFile-img">
      <span class="emptyFile-desc">没有分享文件</span>
    </div>

  </div>
</template>
<script>
import {reactive, toRefs, computed, onMounted, onBeforeUnmount, onBeforeUpdate, watch} from 'vue';
import {useStore} from 'vuex'
import signUtils from "@/libs/signUtils";
import {useRoute, useRouter} from 'vue-router'
import {
  shareFileDeatil, shareFolderDeatil, FolderList, NewFolder, shareReport, AllFileSave
} from "@/api/diskApp/share";
import {ElMessage} from 'element-plus'
import util from '@/libs/util';
import {
  getDefaultIcon, getIconInfo, imgError, showTime, validDays, renderSize, getUrl, getFileType, allFileDown, debounce,
  zipDownload
} from "@/libs/document";
import {preview} from 'vue3-preview-image' // 使用setup组合式api时引入方法调用
import NavBar from "@/pages/diskConsole/shareFile/components/NavBar";
import ShareCodeModel from "@/pages/diskConsole/shareFile/components/ShareCodeModel";
import PcReportModel from "@/pages/diskConsole/shareFile/components/PcReportModel";
import LoginModel from "@/pages/diskConsole/shareFile/components/LoginModel";
import WhiteUser from "@/pages/diskConsole/shareFile/components/WhiteUser";
import VipModel from "@/pages/diskConsole/shareFile/components/VipModel";
import foldericon from '@/assets/images/tab_file/icon/folder.png'
import defaultAvatar from "@/assets/images/tab_mine/avatar/default.png";
import {Vue3SeamlessScroll} from "vue3-seamless-scroll"
// const elementResizeDetectorMaker = require('element-resize-detector')

export default {
  components: {
    NavBar,
    ShareCodeModel,
    PcReportModel,
    LoginModel,
    WhiteUser,
    VipModel,
    Vue3SeamlessScroll
  },
  setup() {
    const route = useRoute()
    let querycode = route.query.code
    const store = useStore()
    const router = useRouter()
    let shareId = signUtils.idEncrypt(route.params.shareId)
    // let downUserId = computed(() => {
    //   return store.state.admin.account.info.userId == undefined ? null : store.state.admin.account.info.userId
    // })

    let videoVipShow = computed(() => {
      if (store.state.admin.account.info.isVip) {
        return true
      }
      return false
    })

    let data = reactive({
      FirstBeginOuterData: {
        map: {}
      },
      fullScreenLoad: true,
      havaShareFile: false,
      haveShareCode: false,
      isFolder: false,
      isFile: false,
      dialogVisible: false,
      dialogPhoeMsgModel: false,
      SaveFiledialog: false,
      isTransfer: '',
      Reportdialog: false,
      WhiteUserDialog: false,
      FileInfoShow: false,
      searchoffet: 1,
      searchilimt: 60,
      searchtotal: 0,
      searchLoadMore: false,
      searchModelShow: false,
      searchInputVal: '',
      searchList: [],
      searchFileName: '',
      getSearchDom: null,
      VideoDom: null,
      isShowTitle: true,
      dataLoading: true,
      loading: false,
      islistempty: false,
      onloadMore: false,
      fit: 'contain',
      isIconClass: false,
      iscenterImage: false,
      VipModelShow: false,
      offset: 1,
      limit: 60,
      total: 0,
      saveFileFolderid: '',
      saveFileFolderName: '',
      jumpPc: false,
      jumpPcObj: {},
      newFloderName: '新建文件夹',
      newFolderInputShow: false,
      outerLayerName: '',
      listShowIcon: -1,
      folderList: [],
      transferLoading: false,
      saveFileLoading: false,
      globalFileIds: [],
      globalFolderIds: [],
      historySaveFolderInfo: [],
      list: [
        {
          fileList: [
            {}
          ],
          map: {}
        }
      ],
      currentFolderDesc: {
        userName: '',
        avatar: require('@/assets/images/default.png'),
        folderName: '',
        folderDesc: '',
        shareId: '',
        folderId: '',
        term: '',
        showStars: 1,
        showLikes: 1,
        showDownloads: 1,
        showComments: 1,
        userId: ''
      },
      currentFileInfo: {
        fileIcon: '',
        fileId: '',
        fileName: '',
        fileUrl: '',
        fileSize: '',
        iconId: '',
        type: 0
      },
      historyFolderDesc: [
        // {
        //   folderName: '',
        //   folderDesc: '',
        //   folderId: '',
        // }
      ],
      sortTimeShow: false,
      sortNameShow: false,
      sortSizeShow: false,
      sortParamsData: {
        sort: null, //null-倒序 0-正序
        rule: null //null-时间,1-文件名,2-文件大小
      },
      checkboxGroup: null,
      checkAll: false,
      checkList: [],
      toVipType: 1,
      audioDom: null
    })

    const load = () => {
      if (data.list[0].fileList.length >= data.total)
        return
      data.onloadMore = true
      data.offset++
      getFoldeInfoData(data.currentFolderDesc.folderId)
    }

    const searchLoad = () => {
      if (data.searchList.length >= data.searchtotal)
        return
      data.searchLoadMore = true
      data.searchoffet++
      shareFolderDeatil({
        shareId: data.currentFolderDesc.shareId,
        folderId: data.currentFolderDesc.folderId == '' ? null : data.currentFolderDesc.folderId,
        // folderId: data.currentFolderDesc.folderId || data.currentFileInfo.fileId,
        offset: data.searchoffet,
        limit: data.searchilimt,
        search: data.searchInputVal
      }).then(res => {
        data.searchList.push(...res.list)
        data.searchtotal = res.total
        data.searchLoadMore = false
      })
    }

    function setFirstBeginOuterData(newval) {
      data.FirstBeginOuterData.map = newval.map
      data.FirstBeginOuterData.addTime = newval.addTime
      data.FirstBeginOuterData.amt = newval.amt
      data.FirstBeginOuterData.chkDesc = newval.chkDesc
      data.FirstBeginOuterData.chkStaff = newval.chkStaff
      data.FirstBeginOuterData.chkTime = newval.chkTime
      data.FirstBeginOuterData.code = newval.code
      data.FirstBeginOuterData.favorite = newval.favorite
      data.FirstBeginOuterData.fileIds = newval.fileIds
      data.FirstBeginOuterData.folderIds = newval.folderIds
      data.FirstBeginOuterData.isBuy = newval.isBuy
      data.FirstBeginOuterData.isFavorite = newval.isFavorite
      data.FirstBeginOuterData.shareDesc = newval.shareDesc
      data.FirstBeginOuterData.shareId = newval.shareId
      data.FirstBeginOuterData.shareUrl = newval.shareUrl
      data.FirstBeginOuterData.showComments = newval.showComments
      data.FirstBeginOuterData.showDownloads = newval.showDownloads
      data.FirstBeginOuterData.showLikes = newval.showLikes
      data.FirstBeginOuterData.showRecommend = newval.showRecommend
      data.FirstBeginOuterData.showStars = newval.showStars
      data.FirstBeginOuterData.showUpTime = newval.showUpTime
      data.FirstBeginOuterData.status = newval.status
      data.FirstBeginOuterData.term = newval.term
      data.FirstBeginOuterData.type = newval.type
      data.FirstBeginOuterData.updTime = newval.updTime
      data.FirstBeginOuterData.userId = newval.userId
      data.FirstBeginOuterData.folderName = newval.fileList[0].folderName
      data.FirstBeginOuterData.fileName = newval.fileList[0].fileName
    }

    function getData() {
      shareFileDeatil(
          {
            shareId: shareId,
            userId: store.state.admin.account.info.userId == undefined ? null : store.state.admin.account.info.userId,
            type: 0,
            offset: data.offset,
            limit: data.limit
          }
      ).then(res => {
        if (res.list.length == 0) {
          data.havaShareFile = true
          data.fullScreenLoad = false
          return
        } else if (res.list[0].code && !data.isFolder && !data.isFile && querycode != signUtils.decryptHex(res.list[0].code)) {
          data.haveShareCode = true
          if (res.list[0].fileList.length == 1 && res.list[0].fileList[0].fileType == 1) {
            data.currentFileInfo.fileName = res.list[0].fileList[0].fileName
            data.currentFileInfo.fileUrl = res.list[0].fileList[0].fileUrl
            data.currentFileInfo.fileId = res.list[0].fileList[0].fileId
            data.currentFileInfo.fileIcon = res.list[0].fileList[0].fileIcon
            data.currentFileInfo.fileSize = res.list[0].fileList[0].fileSize
            data.currentFileInfo.iconId = res.list[0].fileList[0].iconId
            data.currentFileInfo.type = res.list[0].fileList[0].type
            data.currentFileInfo.fileDesc = res.list[0].fileList[0].fileDesc
          }
          if (res.list[0].fileList.length == 1 && res.list[0].fileList[0].fileType == 2) {
            data.outerLayerName = res.list[0].fileList[0].folderName
          }
        } else if (res.list[0].fileList.length >= 2 || res.list[0].fileList[0].fileType == 2) {
          data.isFolder = true
          if (res.list[0].fileList.length == 1) {
            data.currentFolderDesc.folderId = res.list[0].fileList[0].folderId
            data.currentFolderDesc.folderName = res.list[0].fileList[0].folderName
            data.currentFolderDesc.folderDesc = res.list[0].fileList[0].folderDesc
            data.outerLayerName = res.list[0].fileList[0].folderName
          } else {
            data.currentFolderDesc.folderId = ''
            data.sortParamsData.sort = -1
            data.sortParamsData.rule = -1
          }
        } else {
          data.isFile = true
          data.currentFileInfo.fileName = res.list[0].fileList[0].fileName
          data.currentFileInfo.fileUrl = res.list[0].fileList[0].fileUrl
          data.currentFileInfo.fileId = res.list[0].fileList[0].fileId
          data.currentFileInfo.fileIcon = res.list[0].fileList[0].fileIcon
          data.currentFileInfo.fileSize = res.list[0].fileList[0].fileSize
          data.currentFileInfo.iconId = res.list[0].fileList[0].iconId
          data.currentFileInfo.type = res.list[0].fileList[0].type
          data.currentFileInfo.fileDesc = res.list[0].fileList[0].fileDesc
          addListen()
        }

        setFirstBeginOuterData(res.list[0])
        data.currentFolderDesc.shareId = res.list[0].shareId
        data.currentFolderDesc.userName = res.list[0].map.userName
        data.currentFolderDesc.term = res.list[0].term
        data.currentFolderDesc.avatar = res.list[0].map.avatar
        data.currentFolderDesc.userId = res.list[0].userId

        if (data.isFolder && res.list[0].fileList.length == 1) {
          data.list[0].fileList = []
          getFoldeInfoData(res.list[0].fileList[0].folderId)
        } else {
          data.list = []
          data.list.push(...res.list)
          setTimeout(() => {
            data.dataLoading = false
          }, 100)
        }
        data.fullScreenLoad = false
      })
    }

    function getfolderDesc(val) {  //1简介2时间
      let arraylong = data.historyFolderDesc.length
      let folderDesc = ''
      let timeDesc = ''
      if (data.isFile) {
        folderDesc = data.currentFileInfo.fileDesc == '' || data.currentFileInfo.fileDesc == undefined ? '暂无简介' : data.currentFileInfo.fileDesc
      } else {
        if (arraylong >= 1 && data.historyFolderDesc[arraylong - 1].folderDesc != '') {
          folderDesc = data.historyFolderDesc[arraylong - 1].folderDesc == undefined || data.historyFolderDesc[arraylong - 1].folderDesc == '' ? '暂无简介' : data.historyFolderDesc[arraylong - 1].folderDesc
        } else {
          folderDesc = data.currentFolderDesc.folderDesc != undefined || data.currentFolderDesc.folderDesc != '' ? data.currentFolderDesc.folderDesc : '暂无简介'
        }
      }
      if (folderDesc == '' || folderDesc == undefined || folderDesc == null)
        folderDesc = '暂无简介'
      if (data.currentFolderDesc.term == -1)
        timeDesc = '一次性'
      else
        timeDesc = data.currentFolderDesc.term == 0 ? '永久有效' : validDays(data.FirstBeginOuterData.updTime, data.currentFolderDesc.term) + '天后过期'
      return val == 1 ? folderDesc : timeDesc
    }

    function ShareCodeModelColse(code) {
      data.haveShareCode = false
      querycode = code
      if (data.list[0].fileList.length >= 2 || data.list[0].fileList[0].fileType == 2) {
        if (data.list[0].fileList.length == 1) {
          let folderId = data.list[0].fileList[0].folderId
          data.list[0].fileList = []
          getFoldeInfoData(folderId)
        }
        data.isFolder = true
      } else {
        data.isFile = true
      }
    }

    function getFoldeInfoData(folderId) {
      shareFolderDeatil({
        shareId: data.currentFolderDesc.shareId,
        folderId: folderId == '' ? null : folderId,
        offset: data.offset,
        limit: data.limit,
        search: data.searchFileName == '' ? undefined : data.searchFileName
      }).then(res => {

        data.isFolder = true
        data.currentFileInfo.fileId = ''
        data.currentFileInfo.fileName = ''
        data.currentFolderDesc.folderId = folderId

        data.list[0].fileList.push(...res.list)
        data.dataLoading = false
        if (data.list[0].fileList.length == 0) {
          data.islistempty = true
        } else data.islistempty = false

        data.total = res.total
        data.onloadMore = false
      })
    }

    function jump(item) {
      data.checkList = []
      data.checkAll = false
      if (item.fileType == 1) {
        data.currentFileInfo.fileName = item.fileName
        data.currentFileInfo.fileUrl = item.fileUrl
        data.currentFileInfo.fileIcon = item.fileIcon
        data.currentFileInfo.fileId = item.fileId
        data.currentFileInfo.updTime = item.updTime
        data.currentFileInfo.iconId = item.iconId
        data.currentFileInfo.type = item.type
        data.currentFileInfo.fileSize = item.fileSize
        data.currentFileInfo.fileDesc = item.fileDesc
        data.historyFolderDesc.push(
            {
              folderName: item.fileName
            }
        )
        var FileVideoPlay = document.getElementById('videoPlay')
        if (FileVideoPlay != null)
          FileVideoPlay.load()
        var FileAudeoPlay = document.getElementById('audioPlay')
        if (FileAudeoPlay != null)
          FileAudeoPlay.load()
        data.isFile = true
        data.isFolder = false
        data.iscenterImage = true
        addListen()
        return
      }
      data.historyFolderDesc.push({
        folderName: item.folderName,
        folderId: item.folderId,
        folderDesc: item.folderDesc,
        fileType: item.fileType,
        updTime: item.updTime
      })
      data.currentFolderDesc.folderName = item.folderName
      data.currentFolderDesc.folderDesc = item.folderDesc
      data.currentFolderDesc.folderId = item.folderId
      data.dataLoading = true
      data.offset = 1
      data.list[0].fileList = []
      data.sortParamsData.rule = null
      data.sortParamsData.sort = null
      getFoldeInfoData(item.folderId)
    }

    function backLevel(item) {
      data.checkList = []
      data.checkAll = false
      data.islistempty = false
      var FileVideoPlay = document.getElementById('videoPlay')
      if (FileVideoPlay != null)
        FileVideoPlay.pause()
      if (item == 'first-title' || item == undefined) {  //首页或返回最上级
        data.offset = 1
        data.historyFolderDesc = []
        // data.currentFolderDesc.folderId = ''
        data.currentFolderDesc.folderDesc = ''
        data.currentFileInfo.fileId = ''
        data.sortParamsData.sort = null
        data.sortParamsData.rule = null
        data.isFile = false
        getData()
        return;
      }

      if (item.folderId == undefined)
        return;
      if (data.iscenterImage) {
        data.iscenterImage = false
        data.isFile = false
        data.currentFileInfo.fileId = ''
      }
      for (let i = data.historyFolderDesc.length; i > 0; i--) {
        if (data.historyFolderDesc[i - 1].folderId == item.folderId) {
          data.dataLoading = true
          data.offset = 1
          data.list[0].fileList = []
          data.sortParamsData.rule = null
          data.sortParamsData.sort = null
          getFoldeInfoData(item.folderId)
          return
        } else {
          data.historyFolderDesc.pop()
        }
      }
    }

    function LogincloseModel() {
      data.dialogVisible = false
    }

    function VipcloseModel() {
      data.VipModelShow = false
      data.toVipType = 1
    }

    function PcReportcloseModel() {
      data.Reportdialog = false
    }

    function closeWhiteUserModel() {
      data.WhiteUserDialog = false
    }

    function closeDiv(e) {
      if (data.getSearchDom != null) {
        if (!data.getSearchDom.contains(e.target) && e.target.className != 'folder-search') {
          data.searchModelShow = false
          closeSearch()
        }
        if (data.getSearchDom.contains(e.target) && e.target.className == 'common-input-close') {
          data.searchModelShow = false
          closeSearch()
        }
      }
    }

    function closeSearchFile() {
      data.searchInputVal = ''
      data.FileInfoShow = false
    }

    let lastInput = null;  // 上一次输入的延迟
    function searchData() {
      clearTimeout(lastInput);
      lastInput = setTimeout(() => {
        if (data.searchInputVal == '')
          return
        shareFolderDeatil({
          shareId: data.currentFolderDesc.shareId,
          // folderId: data.currentFolderDesc.folderId || data.currentFileInfo.fileId,
          folderId: data.currentFolderDesc.folderId == '' ? null : data.currentFolderDesc.folderId,
          offset: data.searchoffet,
          limit: data.searchilimt,
          search: data.searchInputVal
        }).then(res => {
          data.searchList = []
          data.searchList.push(...res.list)
          data.searchtotal = res.total
        })
      }, 300)
    }

    function getimgUrl(item) {
      if (item.fileType == 2) {
        return getDefaultIcon(1)
      } else if (item.fileType == 1) {
        if (item.fileIcon.indexOf('assets') != 0) {
          return getUrl(item.fileIcon, item.fileName)
        } else {
          return getDefaultIcon(item.iconId)
        }
      }
    }

    function getAvatarUrl(val) {
      if (val == null)
        return defaultAvatar
      if (val != undefined && val.indexOf('assets') == 0) {
        let url = val.slice(0, val.lastIndexOf('.'))
        return require('@/' + `${url}` + '.png')
      }
      return val
    }

    function searchItem(item) {
      if (item.fileType == 1) {
        if (item.iconId == 16) {
          data.searchModelShow = false
          let imgSeeUrl = allFileDown(item.fileId, true)
          preview(imgSeeUrl)
        } else {
          data.currentFileInfo.fileName = item.fileName
          data.currentFileInfo.fileUrl = item.fileUrl
          data.currentFileInfo.fileIcon = item.fileIcon
          data.currentFileInfo.fileId = item.fileId
          data.currentFileInfo.updTime = item.updTime
          data.currentFileInfo.iconId = item.iconId
          data.currentFileInfo.fileSize = item.fileSize
          data.currentFileInfo.type = item.type
          data.currentFileInfo.fileDesc = item.fileDesc
          data.FileInfoShow = true
          addListen()
        }
      } else {
        data.historyFolderDesc.push({
          folderName: item.folderName,
          folderId: item.folderId,
          folderDesc: item.folderDesc,
          fileType: item.fileType,
          updTime: item.updTime
        })
        data.currentFolderDesc.folderDesc = item.folderDesc
        data.currentFolderDesc.folderId = item.folderId
        data.dataLoading = true
        data.offset = 1
        data.list[0].fileList = []
        getFoldeInfoData(item.folderId)
        data.searchModelShow = false
      }
    }

    function closeSearch() {
      data.searchoffet = 1
      data.searchList = []
      data.searchtotal = 0
      data.searchInputVal = ''
    }

    function geticonUrl(item) {
      if (item == undefined)
        return
      if (item.fileType == 2) {
        return foldericon
      } else if (item.fileType == 1) {
        if (item.fileIcon.indexOf('assets') != 0) {
          if (data.isFolder) {
            return getUrl(item.fileIcon, item.fileName)
          }
        } else {
          return getDefaultIcon(item.iconId)
        }
      }
    }

    function getCenterImgUrl(cufileinfo) {
      if (cufileinfo.iconId == 16) {
        return allFileDown((cufileinfo.fileId != null ? cufileinfo.fileId : data.currentFileInfo.fileId), true)
      }
      if (data.currentFileInfo.fileIcon.indexOf('assets') == 0) {
        return getDefaultIcon(cufileinfo.iconId)
      } else {
        return getUrl(data.currentFileInfo.fileIcon, cufileinfo.fileName)
      }
    }

    function downFileCheck(cufileinfo, audioFlag) {
      if (!videoVipShow.value && audioFlag == undefined) {
        return ''
      } else {
        return allFileDown(cufileinfo.fileId, true)
      }
    }

    let gloFileId = null

    function downFile(val) {
      if (val == 'whiteDown') {
        allFileDown((gloFileId != null ? gloFileId : data.currentFileInfo.fileId))
        gloFileId = null
        return
      }
      if (data.FirstBeginOuterData.type == 0 || (data.currentFileInfo.type == 0 && store.state.admin.account.info.isVip != 1&&1==0)) {//白名单弹窗失效
        data.WhiteUserDialog = true
      } else {
        if (data.currentFileInfo.type==0){
          if (util.cookies.get('appToken')==undefined){
            data.dialogVisible = true
            return;
          }else if (!store.state.admin.account.info.isVip){
            data.toVipType = 4
            data.VipModelShow = true
            return;
          }
        }
        debounce(() => {
          allFileDown(data.currentFileInfo.fileId)
        }, 500)
      }
    }

    function listDownFile(val) {
      if (data.FirstBeginOuterData.type == 0 || (val.type == 0 && store.state.admin.account.info.isVip != 1&&1==0)) {//白名单失效
        gloFileId = val.fileId
        data.WhiteUserDialog = true
      } else {
        if (val.type==0){
          if (util.cookies.get('appToken')==undefined){
            data.dialogVisible = true
            return;
          }else if (!store.state.admin.account.info.isVip){
            data.toVipType = 4
            data.VipModelShow = true
            return;
          }
        }
        debounce(() => {
          allFileDown(val.fileId)
        }, 500)
      }
    }

    function beforeReport() {
      if (store.state.admin.account.info.userId == 2) {
        data.VipModelShow = true
        return;
      }
      const token = util.cookies.get('appToken');
      if (token == undefined) {
        data.dialogVisible = true
        return
      } else
        data.Reportdialog = true
    }

    function PcReport(obj) {
      let connectType
      if (data.isFile && data.currentFileInfo.fileId != '') {
        connectType = 1
      } else if (data.currentFolderDesc.folderId != '') {
        connectType = 2
      } else if (data.list[0].fileList.length > 1) {
        connectType = 3
      }
      let connectId
      if (connectType == 1) connectId = data.currentFileInfo.fileId
      else if (connectType == 2) connectId = data.currentFolderDesc.folderId
      else connectId = data.currentFolderDesc.shareId
      shareReport({
            targetId: data.currentFolderDesc.userId,
            connectType: connectType,
            connectId: connectId,
            reportType: obj.reportRadio,
            profitType: obj.profitType,
            reason: obj.reportReason
          },
          obj.formData).then(() => {
        data.Reportdialog = false
        ElMessage({
          message: '举报成功',
          type: 'success',
          center: true,
        })
      }).catch(err => {
        let msg = err.message
        ElMessage.error({
          message: msg.slice(0, msg.lastIndexOf(':')),
          center: true
        })
      })
    }

    function whiteShow() {
      const token = util.cookies.get('appToken');
      if (token == undefined) {
        data.dialogVisible = true
        return
      }
      data.toVipType = 2
      data.VipModelShow = true
      // if (data.FirstBeginOuterData.type == 0 || (data.currentFileInfo.type == 0 && store.state.admin.account.info.isVip != 1)) {
      //   data.WhiteUserDialog = true
      // }
    }

    function getShowName() {
      let connectType
      if (data.isFile && data.currentFileInfo.fileId != '') {
        connectType = 1
      } else if (data.currentFolderDesc.folderId != '') {
        connectType = 2
      } else if (data.list[0].fileList.length > 1) {
        connectType = 3
      }
      let name = data.historyFolderDesc.length ? data.historyFolderDesc[data.historyFolderDesc.length - 1].folderName : (data.FirstBeginOuterData.folderName == undefined || data.FirstBeginOuterData.folderName == null
          ? data.FirstBeginOuterData.fileName + (connectType == 3 ? '等多项' : '') : data.FirstBeginOuterData.folderName + (connectType == 3 ? '等多项' : ''))
      return name == undefined ? '' : name
    }

    function beforeSaveFileFolder(val, item) {
      const token = util.cookies.get('appToken');
      if (token == undefined) {
        data.dialogVisible = true
        return
      }
      // if (!store.state.admin.account.info.isVip) {
      //   data.VipModelShow = true
      //   data.saveFileLoading = false
      //   return
      // }
      if (data.saveFileLoading) {
        ElMessage({
          message: '正在转存',
          type: 'warning',
          center: true,
        })
        return;
      }
      data.globalFileIds = []
      data.globalFolderIds = []
      if (val == 1) {   //多选

        // let downList = data.checkList.filter(item =>
        //     item.fileType == 1)
        // console.log(downList)
        // if (downList.length == 0) {
        //   ElMessage.error({
        //     message: '不能为空',
        //     center: true
        //   })
        //   return;
        // }
        // zipDownload(downList)
        // return;
        if (data.checkList.length > 0) {
          for (let item of data.checkList) {
            if (item.fileType == 2) {
              data.globalFolderIds.push(item.folderId)
            } else if (item.fileType == 1) {
              data.globalFileIds.push(item.fileId)
            }
          }
        }
      } else if (val == 2) {  //行内
        if (item.fileType == 2) {
          data.globalFolderIds.push(item.folderId)
        } else if (item.fileType == 1) {
          data.globalFileIds.push(item.fileId)
        }
      } else if (val == 3) {  //单文件
        data.globalFileIds.push(data.currentFileInfo.fileId)
      }
      saveFolderList()
    }

    function transferFile() {
      const token = util.cookies.get('appToken');
      if (token == undefined) {
        data.dialogVisible = true
        return
      }
      if (data.transferLoading) {
        ElMessage({
          message: '正在转存',
          type: 'warning',
          center: true,
        })
        return;
      }
      let fileIds = []
      let folderIds = []
      if (data.isFolder && data.currentFolderDesc.folderId == '') {  //组合文件转存
        let forValues = Object.values(data.list[0].fileList)
        for (let item of forValues) {
          if (item.fileType == 2) {
            folderIds.push(item.folderId)
          } else if (item.fileType == 1) {
            fileIds.push(item.fileId)
          }
        }
      } else {   //单文件夹转存
        folderIds.push(data.currentFolderDesc.folderId)
      }
      data.transferLoading = true
      AllFileSave({
        targetFileId: fileIds.join(','),
        targetFolderId: folderIds.join(','),
        folderId: 0
      }).then(() => {
        data.transferLoading = false
        data.SaveFiledialog = false
        // ElMessage({
        //   message: '保存成功',
        //   type: 'success',
        //   center: true,
        // })
        let url = 'https://www.feijipan.com/console/files/0?title=我的文件sattus=1&appToken=' + util.cookies.get('appToken')
        data.jumpPcObj = {
          url: url,
          folderName: '我的文件'
        }
        data.jumpPc = true
        setTimeout(() => {
          data.jumpPc = false
        }, 3000)
        data.saveFileFolderid = ''
        data.saveFileFolderName = ''
      }).catch((err) => {
        if (!store.state.admin.account.info.isVip) {
          data.VipModelShow = true
        } else {
          let msg = err.message
          ElMessage.error({
            message: '保存失败,' + msg.slice(0, msg.lastIndexOf(':')),
            center: true
          })
        }
        data.transferLoading = false
      })
    }

    function saveFolderList() {
      FolderList({
        folderId: data.saveFileFolderid,
        offset: 1,
        limit: 60
      }).then(res => {
        data.SaveFiledialog = true
        data.folderList = []
        data.folderList.push(...res.list)
        data.newFloderName = '新建文件夹'
      })
    }

    function savaFileJump(item) {
      data.saveFileFolderid = item.folderId
      data.saveFileFolderName = item.folderName
      data.newFolderInputShow = false
      data.historySaveFolderInfo.push({
        folderId: item.folderId,
        folderName: item.folderName
      })
      saveFolderList()
    }

    function saveFolderJumpLevel(item) {
      if (item == 'firstAll') {
        data.saveFileFolderid = ''
        data.saveFileFolderName = ''
        data.historySaveFolderInfo = []
        saveFolderList()
        return;
      }
      for (let i = data.historySaveFolderInfo.length; i > 0; i--) {
        if (data.historySaveFolderInfo[i - 1].folderId == item.folderId) {
          data.saveFileFolderid = item.folderId
          data.saveFileFolderName = item.folderName
          saveFolderList()
          return
        } else {
          data.historySaveFolderInfo.pop()
        }
      }
    }

    function cancleSaveFile() {
      gloFileId = null
      data.SaveFiledialog = false
      data.newFolderInputShow = false
      data.historySaveFolderInfo = []
      data.folderList = []
      data.saveFileFolderid = ''
      data.saveFileFolderName = ''
    }

    function handleCheckAllChange() {
      if (data.checkAll) {
        data.checkboxGroup.toggleAll(true);
      } else {
        if (data.checkList.length == data.list[0].fileList.length) {
          data.checkboxGroup.toggleAll(false);
        } else data.checkboxGroup.toggleAll(true);
      }
    }

    function handleCheckOne() {
      if (data.checkList.length) {
        data.checkAll = true
      } else data.checkAll = false
    }

    function saveFileToFolder() {
      if (data.saveFileLoading) {
        ElMessage({
          message: '正在转存',
          type: 'warning',
          center: true,
        })
        return;
      }
      data.saveFileLoading = true
      AllFileSave({
        targetFileId: data.globalFileIds.join(','),
        targetFolderId: data.globalFolderIds.join(','),
        folderId: data.saveFileFolderid
      }).then(() => {
        data.saveFileLoading = false
        data.SaveFiledialog = false
        data.historySaveFolderInfo = []
        data.folderList = []
        gloFileId = null
        data.transferLoading = false
        // ElMessage({
        //   message: '保存成功',
        //   type: 'success',
        //   center: true,
        // })
        let url = 'https://www.feijipan.com/console/files/' + (data.saveFileFolderid == '' ? 0 : data.saveFileFolderid) + '?title=' + data.saveFileFolderName + '&sattus=1&appToken=' + util.cookies.get('appToken')
        data.jumpPcObj = {
          url: url,
          folderName: data.saveFileFolderName
        }
        data.jumpPc = true
        setTimeout(() => {
          data.jumpPc = false
        }, 3000)
        data.saveFileFolderid = ''
        data.saveFileFolderName = ''
      }).catch((err) => {
        gloFileId = null
        if (!store.state.admin.account.info.isVip) {
          data.VipModelShow = true
        } else {
          let msg = err.message
          ElMessage.error({
            message: '保存失败,' + msg.slice(0, msg.lastIndexOf(':')),
            center: true
          })
        }
        data.saveFileLoading = false
      })
    }

    function saveNewFolder() {
      NewFolder({
        folderId: data.saveFileFolderid,
        folderName: data.newFloderName
      }, {}).then(() => {
        data.newFolderInputShow = false
        data.newFloderName = '新建文件夹'
        saveFolderList()
      })
    }

    function jumpTOpC() {
      window.open(data.jumpPcObj.url)
      data.jumpPc = false
    }

    function handleClose() {
      data.dialogVisible = false
    }

    function NavBarLogin() {
      data.dialogVisible = true
    }

    function showPreviewImg() {
      if (videoVipShow.value && data.currentFileInfo.iconId == 16) {
        let imgSeeUrl = allFileDown(data.currentFileInfo.fileId, true)
        preview(imgSeeUrl)
      }
      if (!videoVipShow.value & data.currentFileInfo.iconId == 5) {
        const token = util.cookies.get('appToken');
        if (token == undefined) {
          data.dialogVisible = true
          return
        }
        data.toVipType = 3
        data.VipModelShow = true
      }
    }

    function sortList(sort, rule) {
      if (rule != data.sortParamsData.rule) {
        if (sort == null) sort = 0
        else sort = null
      }
      data.sortParamsData.sort = sort
      data.sortParamsData.rule = rule
      data.sortNameShow = false
      data.sortTimeShow = false
      data.sortSizeShow = false
      data.offset = 1
      shareFolderDeatil({
        shareId: data.currentFolderDesc.shareId,
        folderId: data.currentFolderDesc.folderId == '' ? null : data.currentFolderDesc.folderId,
        offset: data.offset,
        limit: data.limit,
        search: data.searchFileName == '' ? undefined : data.searchFileName,
        ...data.sortParamsData
      }).then(res => {
        data.dataLoading = true
        setTimeout(() => {
          data.dataLoading = false
        }, 300)
        data.list[0].fileList = []
        data.list[0].fileList.push(...res.list)
        if (data.list[0].fileList.length == 0) {
          data.islistempty = true
        } else data.islistempty = false
        data.total = res.total
        data.onloadMore = false
      })
    }

    function sortmounte(val) {
      if (val == null && data.sortParamsData.sort != -1) {
        if (data.sortParamsData.rule == null)
          data.sortTimeShow = false
        else data.sortTimeShow = true
      } else if (val == 1 && data.sortParamsData.sort != -1) {
        if (data.sortParamsData.rule == 1)
          data.sortNameShow = false
        else data.sortNameShow = true
      } else if (val == 2 && data.sortParamsData.sort != -1) {
        if (data.sortParamsData.rule == 2)
          data.sortSizeShow = false
        else data.sortSizeShow = true
      }
    }

    function sortlevel(val) {
      if (val == null && data.sortParamsData.sort != -1) {
        data.sortTimeShow = false
      } else if (val == 1 && data.sortParamsData.sort != -1) {
        data.sortNameShow = false
      } else if (val == 2 && data.sortParamsData.sort != -1) {
        data.sortSizeShow = false
      }
    }

    function addListen() {
      setTimeout(() => {
        let audio = data.audioDom
        if (audio != null) {
          audio.loop = false;
          audio.addEventListener('error', function () {
          }, false);
          audio.addEventListener('play', function () {
            const token = util.cookies.get('appToken');
            if (token == undefined) {
              data.dialogVisible = true
              audio.pause();
              return
            }
            if (videoVipShow.value == false) {
              audio.pause();
              data.toVipType = 3
              data.VipModelShow = true
            }
          }, false);
          audio.addEventListener('pause', function () {
          }, false);
        }
      }, 500)
    }

    onMounted(() => {
      getData()
      // let erd = elementResizeDetectorMaker();
      // erd.listenTo(document.getElementById('share-left'), (ele) => {
      //   console.log(ele.clientWidth)
      // })
    })

    onBeforeUnmount(() => {
    })

    return {
      load,
      searchLoad,
      jump,
      ShareCodeModelColse,
      backLevel,
      getfolderDesc,
      closeDiv,
      videoVipShow,
      whiteShow,
      transferFile,
      beforeSaveFileFolder,
      downFileCheck,
      LogincloseModel,
      VipcloseModel,
      PcReportcloseModel,
      closeWhiteUserModel,
      closeSearchFile,
      getCenterImgUrl,
      getIconInfo,
      getAvatarUrl,
      geticonUrl,
      getimgUrl,
      imgError,
      searchItem,
      renderSize,
      showTime,
      downFile,
      getFileType,
      handleClose,
      beforeReport,
      PcReport,
      handleCheckAllChange,
      handleCheckOne,
      savaFileJump,
      saveFolderJumpLevel,
      cancleSaveFile,
      saveFileToFolder,
      saveNewFolder,
      NavBarLogin,
      showPreviewImg,
      searchData,
      closeSearch,
      sortList,
      sortmounte,
      sortlevel,
      listDownFile,
      jumpTOpC,
      getShowName,
      ...toRefs(data)
    };
  }
}
</script>

<style scoped>

:deep(.el-loading-spinner) {
  top: 30%;
}

:deep(.preview-wrap[data-v-22093558]) {
  background: white;
}

.loading {
  position: fixed;
  height: 100%;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
  background-color: white;
}

.share-container {
  width: 100%;
  height: 100%;
  display: flex;
  /*flex-direction: column;*/
  flex-wrap: nowrap;
  min-width: 850px;
  overflow: hidden !important;
  background-color: #F7F7F7;
}


.center-top-box {
  height: 105px;
  width: 100%;
  box-sizing: border-box;
  overflow: hidden;
  display: flex;
  align-items: center;
  /*background-color: #D8F4FF;*/
}

.left-userdesc-wrapper {
  width: 61%;
  height: 99%;
  padding-left: 34px;
  display: flex;
  flex-direction: column;
}

.left-userdesc-username {
  display: flex;
  align-items: center;
  margin-top: 35px;
  font-family: 'PingFang SC';
  font-style: normal;
  font-weight: 600;
  font-size: 16px;
  color: #25262B;
  width: 90%;
  height: 26px;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
  position: relative;
}

.left-folder-desc {
  height: 13px;
  width: 89%;
  margin-top: 8px;
  font-family: 'PingFang SC';
  font-size: 10px;
  line-height: 13px;
  color: #626266;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.right-userdesc-wrapper {
  display: flex;
  align-items: center;
  flex: 1;
  height: 99%;
  position: relative;
}


.center-top-warpper {
  height: 72px;
  width: 100%;
  display: flex;
  align-items: center;
}

.user-info-fixed {
  position: absolute;
  width: 202px;
  height: 191px;
  left: 26px;
  top: 81px;
  background: #FFFFFF;
  z-index: 100;
  display: flex;
  flex-direction: column;
  align-items: center
}

.userimg {
  border-radius: 50%;
  margin-top: 37px;
  image-rendering: -moz-crisp-edges;
  image-rendering: -o-crisp-edges;
  image-rendering: -webkit-optimize-contrast;
  image-rendering: crisp-edges;
  width: 51px;
  height: 51px;
  mix-blend-mode: normal;
  border: 3px solid #D9E2EA;
}

.user-name {
  width: 90%;
  display: flex;
  justify-content: center;
  height: 13px;
  margin-top: 18px;
  font-family: 'PingFang SC';
  font-size: 14px;
  line-height: 13px;
  color: #333333;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.share-time {
  font-family: 'PingFang SC';
  font-size: 12px;
  line-height: 13px;
  margin-top: 8px;
  color: #BDBDBD;
}

.container {
  height: 72px;
  margin-left: 16px;
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  position: relative;
}

.title-wrapper {
  height: 30px;
  max-width: 1200px;
  overflow: hidden;
  display: flex;
  align-items: center;

}

.title-firstname {
  color: rgb(187, 187, 187);
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  display: table-cell;
  width: auto;
  max-width: 170px;
  cursor: pointer;
}

.title-container {
  display: flex;
  align-items: center;
  margin-left: 10px;
  /*max-width: 135px;*/
  color: rgb(187, 187, 187);
  cursor: pointer;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.title-first-container {
  display: flex;
  align-items: center;
  margin-left: 10px;
  color: rgb(187, 187, 187);
  cursor: pointer;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.svgicon {
  width: 16px;
  margin-right: 3px;
}

.next-title {
  max-width: 115px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.next-title-end {
  width: auto;
}

.folderdesc-wrapper {
  width: 80%;
  line-height: 21px;
  max-height: 42px;
  /*max-width: 1200px;*/
  font-size: 14px;
  color: gray;
  overflow: hidden;
  text-overflow: ellipsis;
  user-select: text;
  word-break: break-all;
}

.icon-wrapper {
  position: absolute;
  right: 0px;
  width: 270px;
  height: 61px;
  background-color: white;
  z-index: 12;
  display: flex;
  align-items: center;
}

.searchimg {
  position: absolute;
  right: 207px;
  height: 22px;
  cursor: pointer;
}

.transferimg {
  position: absolute;
  right: 92px;
  height: 18px;
  cursor: pointer;
}

.down-btn {
  position: absolute;
  width: 76px;
  height: 36px;
  right: 286px;
  cursor: pointer;
  background-color: white;
  z-index: 11;
}

.folder-search {
  position: absolute;
  width: 76px;
  height: 36px;
  right: 232px;
  cursor: pointer;
  background-color: white;
  z-index: 11;
}

.save-img {
  position: absolute;
  width: 160px;
  height: 36px;
  right: 113px;
  cursor: pointer;
  background-color: white;
  z-index: 11;
}

.checktransferimg {
  position: absolute;
  width: 104px;
  height: 36px;
  right: 113px;
  cursor: pointer;
}

.reportimg {
  position: absolute;
  width: 76px;
  height: 36px;
  right: 24px;
  cursor: pointer;
}

.remote-search {
  position: absolute;
  top: 166px;
  left: 50%;
  transform: translateX(-60%);
  width: 600px;
  max-height: 500px;
  border-radius: 10px;
  box-shadow: 0 0 10px #ccc;
  z-index: 15;
  background-color: white;
  display: flex;
  flex-direction: column;
}

.search-input-warpper {
  height: 50px;
  width: 600px;
  border-radius: 10px;
  display: flex;
  align-items: center;
}

.common-input {
  width: 550px;
  height: 50px;
  border-radius: 10px;
}

.common-input-inner {
  border: none;
  outline: none;
  height: 50px;
  width: 486px;
  padding-left: 20px;
  border-radius: 10px;
}

.common-input-clear {
  cursor: pointer;
  font-size: 14px;
  color: gray;
  margin-left: 3px;
}

.common-input-close {
  width: 20px;
  height: 20px;
  margin-left: 10px;
}

.search-list {
  flex: 1;
  border-radius: 10px;
  overflow: auto;
}

.search-item {
  display: flex;
  align-items: center;
  height: 50px;
  padding-left: 20px;
  cursor: pointer;
}

.search-item:hover {
  background-color: #f5f5f5;
}


.section {
  flex: 1;
  margin-top: 81px;
  /*margin-left: 18.9%;*/
  /*margin-right: 30.7%;*/
  box-sizing: border-box;
  /*overflow: hidden;*/
  min-width: 850px;
  background-color: white;
}

.list-container {
  height: 87%;
  overflow: hidden;
  /*background-color: #D8F4FF;*/
}

.list-container-top {
  display: flex;
  align-items: center;
  margin-top: 27px;
  margin-bottom: 22px;
  width: 100%;
  height: 17px;
}

.list-header {
  font-size: 15px;
  color: rgb(176, 177, 179);
  display: flex;
  align-items: center;
  padding-bottom: 6px;
  margin-left: 12px;
  width: 96.26%;
}

.list-header-first {
  flex: 1;
  min-width: 490px;
  display: flex;
  align-items: center;
}

.list-header-second {
  flex: 1;
  min-width: 210px;
  display: flex;
  align-items: center;
}

.list-header-third {
  max-width: 150px;
  flex: 1;
  display: flex;
  align-items: center;
}

.sort-style {
  height: 13px;
  padding-left: 10px;
  cursor: pointer;
}

.sort-style:hover {
}

.list-wrapper {
  height: 87%;
  overflow: auto;
}

.list-item {
  display: flex;
  align-items: center;
  color: #6e6f74;
  font-size: 14px;
  width: 96.26%;
  margin-left: 12px;
  white-space: nowrap;
  height: 54px;
  line-height: 54px;
  border-top: 1px solid #eee;
  cursor: pointer;
  position: relative;
}

.list-item:hover {
  background-color: #DAECFF;
}

.group-checkbox {
  width: 59px;
  height: 46px;
  display: flex;
  align-items: center;
  flex-shrink: 0;
}

.list-img {
  width: 32px;
  height: 32px;
  flex-shrink: 0;
}

.video-pause-container {
  position: absolute;
  top: 50%;
  left: 67px;
  transform: translateY(-50%);
  width: 18px;
  height: 18px;
  border-radius: 50%;
  background: black;
  opacity: 0.5;
}

.video-pause {
  width: 15px;
  height: 15px;
  position: absolute;
  left: 69px;
  transform: translateY(-50%);
  top: 50%;
}

.list-name {
  text-overflow: ellipsis;
  overflow: hidden;
  margin-left: 12px;
  width: 74%;
  font-family: 'PingFang SC';
  font-size: 14px;
  font-weight: 500;
  line-height: 18px;
  color: #25262B;
}

.list-item-right {
  position: absolute;
  right: 4%
}

.list-down {
  height: 17px;
}

.list-transfer {
  height: 17px;
  padding-left: 12px;
}

.name {
  color: #25262b;
  display: flex;
  align-items: center;
  flex: 1;
  min-width: 490px;
  overflow: hidden;
  position: relative;
}

.time {
  flex: 1;
  min-width: 210px;
  font-family: 'DIN';
  font-style: normal;
  font-weight: 500;
  font-size: 13px;
  line-height: 16px;
  color: #626266;
}

.size {
  text-indent: 6px;
  flex: 1;
  max-width: 150px;
  font-family: 'DIN';
  font-style: normal;
  font-weight: 500;
  font-size: 13px;
  line-height: 16px;
  color: #626266;
}

.list-loading {
  font-size: 14px;
  text-align: center;
  height: 40px;
  line-height: 40px;
  color: #b0b1b3;
}

.empty-filelist-container {
  width: 100%;
  height: 100%;
  margin-top: -50px;
  margin-left: -30px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.empty-filelist {
  height: 160px;
}

.empty-filelist-desc {
  font-size: 14px;
  text-align: center;
  height: 40px;
  line-height: 40px;
  color: #b0b1b3;
}


.centerimg-container {
  height: 100%;
  box-sizing: border-box;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  align-content: center;
}

.img-wrapper {
  margin-top: 34px;
  width: 100%;
  max-height: 500px;
  min-height: 330px;
  display: flex;
  justify-content: center;
  position: relative;
}

.file-video-pause {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background: black;
  opacity: 0.5;
  cursor: pointer;
}

.file-video-pause-img {
  width: 30px;
  height: 30px;
  position: absolute;
  left: 50.2%;
  transform: translate(-50%, -50%);
  top: 50%;
  cursor: pointer;
}

.img-center {
  height: 124px;
  /*object-fit: cover;*/
  image-rendering: -moz-crisp-edges;
  image-rendering: -o-crisp-edges;
  image-rendering: -webkit-optimize-contrast;
  image-rendering: crisp-edges;
}

.img-center-active {
  max-height: 491px;
  height: 100%;
  max-width: 100%;
  min-height: 330px;
  /*object-fit: cover;*/
  image-rendering: -moz-crisp-edges;
  image-rendering: -o-crisp-edges;
  image-rendering: -webkit-optimize-contrast;
  image-rendering: crisp-edges;
}

.filename-container {
  width: 100%;
  display: flex;
  justify-content: center;
  margin-top: 23px;
  font-family: 'PingFang SC';
  font-size: 14px;
  color: #B3B3B5;
}

.filename {
  font-size: 17px;
  display: flex;
  justify-content: left;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.filesize {
  display: flex;
  justify-content: center;
  margin-top: 7px;
  font-family: 'DIN';
  font-style: normal;
  font-weight: 500;
  font-size: 17px;
  line-height: 48px;
  color: rgb(187, 187, 187);
}

.btn-container {
  height: 45px;
  margin-top: 70px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.down {
  border: none;
  outline: none;
  width: 145px;
  height: 38px;
  margin-right: 20px;
  border-radius: 18px;
  font-size: 15px;
  color: white;
  cursor: pointer;
  border: 1px solid #eee;
  background-color: #0982FE;
}

.save {
  border: none;
  outline: none;
  width: 145px;
  height: 38px;
  margin-right: 20px;
  border-radius: 18px;
  font-size: 15px;
  cursor: pointer;
  border: 1px solid #eee;
  background-color: #F8F8F9;
}

.presee {
  border: none;
  outline: none;
  width: 145px;
  height: 38px;
  border-radius: 18px;
  font-size: 15px;
  cursor: pointer;
  border: 1px solid #eee;
  background-color: #F8F8F9;
}

.img-preview {
  width: 100%;
  height: 100%;
  position: fixed;
  top: 0;
  left: 0;
  overflow: hidden;
  background: #fff;
  z-index: 1002;
}


.emptyFile {
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin-bottom: 56px;
}

.emptyFile-img {
  height: 150px;
}

.emptyFile-desc {
  font-size: 15px;
  color: #caccd0;
  margin-top: 6px;
}


/*:deep(.el-dialog) {*/
/*  height: 630px;*/
/*  width: 500px;*/
/*  margin: 0 !important;*/
/*  display: flex;*/
/*  flex-direction: column;*/
/*  align-items: center;*/
/*  position: absolute;*/
/*  top: 50%;*/
/*  left: 50%;*/
/*  transform: translate(-50%, -50%);*/
/*  border-radius: 20px;*/
/*  background-color: #F3F7FF;*/
/*  text-align: center;*/
/*}*/

:deep(.myLogin-dialog) {
  height: 425px;
  width: 410px;
  margin: 0 !important;
  display: flex;
  flex-direction: column;
  align-items: center;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  border-radius: 20px;
  background-color: white;
  text-align: center;
}

:deep(.myLogin-dialog .el-dialog__body) {
  padding: 0;
  padding-top: 5px;
  width: 100%;
  height: 100%;
}

:deep(.myVip-dialog) {
  height: 600px;
  width: 750px;
  margin: 0 !important;
  display: flex;
  flex-direction: column;
  align-items: center;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  border-radius: 20px;
}

:deep(.myVip-dialog .el-dialog__header) {
  display: none;
}

:deep(.myVip-dialog .el-dialog__body) {
  padding: 0;
  width: 100%;
  height: 100%;
  font-size: 16px;
}


:deep(.myVip-toBeVip) {
  height: 317px;
  width: 413px;
  margin: 0 !important;
  display: flex;
  flex-direction: column;
  align-items: center;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  border-radius: 20px;
}

:deep(.myVip-toBeVip .el-dialog__header) {
  display: none;
}

:deep(.myVip-toBeVip .el-dialog__body) {
  padding: 0;
  width: 100%;
  height: 100%;
  font-size: 16px;
}

:deep(.pay-dialog) {
  height: 252px;
  width: 860px;
  margin: 0 !important;
  display: flex;
  flex-direction: column;
  align-items: center;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  border-radius: 20px;
}

:deep(.pay-dialog .el-dialog__header) {
  padding: 20px;
  padding-bottom: 10px;
}

:deep(.pay-dialog .el-dialog__body) {
  padding: 30px 45px 60px;
  color: #303133;
  font-size: 16px;
}

:deep(.jumpPc-dialog) {
  height: 100px;
  width: 273px;
  margin: 0 !important;
  display: flex;
  flex-direction: column;
  align-items: center;
  position: absolute;
  top: 15%;
  left: 50%;
  transform: translate(-50%, -50%);
  border-radius: 20px;
}

:deep(.jumpPc-dialog .el-dialog__header) {
  display: none;
}

:deep(.jumpPc-dialog .el-dialog__body) {
  padding: 0;
  width: 100%;
  height: 100%;
  font-size: 16px;
}

phone-code-next {
  cursor: pointer;
  position: absolute;
  right: 10px;
  top: 50%;
  transform: translateY(-50%);
  border-radius: 9px;
  width: 85px;
  height: 33px;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: red;
}


.mydialog {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 1025;
  height: 100%;
  overflow: auto;
}

.mydialog-voerlay {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  left: 0;
  overflow: auto;
}


.SaveFileModel {
  width: 550px;
  height: 500px;
  position: absolute;
  top: 50%;
  left: 50%;
  border-radius: 20px;
  transform: translate(-50%, -50%);
  display: flex;
  flex-direction: column;
  align-items: center;
  background-color: white;
}

.sava-header {
  height: 55px;
  width: 100%;
  border-radius: 20px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.saveFileItem {
  display: flex;
  align-items: center;
  height: 50px;
  cursor: pointer;
}

.saveFileItem:hover {
  background-color: #f5f5f5;
}

:deep(.van-uploader__preview) {
  cursor: auto;
}

:deep(.van-uploader__preview) {
  margin-top: 10px;
}

:deep(.el-textarea__inner) {
  height: 100px;
}

.search-file-container {
  width: 100%;
  height: 100%;
  position: fixed;
  top: 0;
  left: 0;
  overflow: hidden;
  background: #fff;
  z-index: 1024;
}

.contain-wrapper {
  display: flex;
  flex-direction: column;
  height: 100%;
  width: 100%;
}

.search-header {
  height: 60px;
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
}

.search-close {
  width: 25px;
  position: absolute;
  left: 20px;
  cursor: pointer;
}

.search-title {
  text-align: center;
  font-weight: bold;
  font-size: 21px;
  max-width: 600px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.search-center {
  flex: 1;
  background-color: white;
}

.searchimg-wrapper {
  position: relative;
  margin-top: 220px;
  width: 100%;
  max-height: 250px;
  min-height: 120px;
  display: flex;
  justify-content: center;
}

.searchimg-center {
  height: 120px;
  image-rendering: -moz-crisp-edges;
  image-rendering: -o-crisp-edges;
  image-rendering: -webkit-optimize-contrast;
  image-rendering: crisp-edges;
}

::-webkit-scrollbar-track {
  background-color: white;
}

::-webkit-scrollbar {
  width: 6px;
}

::-webkit-scrollbar-thumb {
  background-color: #DEDFE1;
  border-radius: 3px;
}

:deep(.el-radio__input.is-checked .el-radio__inner) {
  background-color: #0982FE;
  border-color: #0982FE;
}

:deep(.el-radio__input.is-checked+.el-radio__label) {
  color: #606266;
  background-color: white;
}

:deep(.el-checkbox__input.is-checked .el-checkbox__inner) {
  background-color: #0982FE;
  border-color: #0982FE;
}

:deep(.van-checkbox) {
  margin-left: 12px;
}

:deep(.van-checkbox__icon .van-icon) {
  border-color: #DCDFE6;
}

:deep(.el-checkbox__input.is-checked+.el-checkbox__label) {
  color: #606266;
  background-color: white;
}

:deep(.el-checkbox .el-checkbox__inner) {
  width: 16px;
  height: 16px;
}

:deep(.el-checkbox__input.is-checked .el-checkbox__inner) {
  background-color: #0982FE;
  border-color: #0982FE;
}

:deep(.el-checkbox__inner:hover) {
  border-color: #0982FE;
}

:deep(.el-checkbox__inner::after) {
  box-sizing: content-box;
  content: '';
  border: 1px solid #FFFFFF;
  border-left: 0;
  border-top: 0;
  height: 10px;
  left: 5px;
  position: absolute;
  top: 1px;
  width: 4px;
}

:deep(.el-checkbox__input.is-checked + .el-checkbox__label) {
  color: inherit;
}

:deep(.el-checkbox__input.is-focus .el-checkbox__inner) {
  border-color: #DCDFE6 !important;
}

:deep(.el-checkbox__input.is-focus.is-checked .el-checkbox__inner) {
  border-color: #0982FE !important;
}


</style>
